import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/litters`;

export const litterService = {
  getAll: async () => {
    const response = await axios.get(API);
    return response.data;
  },

  create: async (data) => {
    const response = await axios.post(API, data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axios.put(`${API}/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`${API}/${id}`);
    return response.data;
  },

  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post(`${API}/upload-image`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data.image;
  }
};
